// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"397":"f5c139f1","453":"2380f626"}[chunkId] + ".chunk.js";
};